__turbopack_context__.v({
  "container": "styles-module__H9-NxW__container",
  "header": "styles-module__H9-NxW__header",
  "section": "styles-module__H9-NxW__section",
  "stepCard": "styles-module__H9-NxW__stepCard",
  "stepContent": "styles-module__H9-NxW__stepContent",
  "stepIcon": "styles-module__H9-NxW__stepIcon",
  "stepIconWrapper": "styles-module__H9-NxW__stepIconWrapper",
  "stepItem": "styles-module__H9-NxW__stepItem",
  "stepsList": "styles-module__H9-NxW__stepsList",
});
